import React from "react";

export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32.79999923706055 31.999000549316406">
        <g fill="#000" fillRule="evenodd">
            <g fillRule="nonzero">
                <path d="M14.8 0C10.121 0 0 4.832 0 16c0 11.166 9.271 15.289 14.8 15.999v-2.64c-5.927-.683-12.412-6.667-12.412-13.333 0-6.667 5.975-12.81 12.412-13.333V0zM18 0c4.679 0 14.8 4.832 14.8 16 0 11.166-9.271 15.289-14.8 15.999v-2.64c5.927-.683 12.412-6.667 12.412-13.333 0-6.667-5.975-12.81-12.412-13.333V0z" />
                <path d="M14.8 5.2c-2.909 0-9.6 3.541-9.6 10.8 0 7.258 6.163 10.337 9.6 10.799v-2.516c-3.684-.444-6.915-3.933-6.915-8.266S10.799 8.09 14.8 7.75V5.2zM18 5.2c2.909 0 9.6 3.541 9.6 10.8 0 7.258-6.163 10.337-9.6 10.799v-2.516c3.684-.444 6.915-3.933 6.915-8.266S22.001 8.09 18 7.75V5.2z" />
            </g>
        </g>
    </svg>
);
